// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.textarea__root_dc0f308f {
  position: relative;
}
.textarea__component_dc0f308f.textarea__component_dc0f308f {
  resize: vertical;
  overflow: auto;
  min-height: 80px;
  padding: 0.667rem;
  display: block;
}
.textarea__component_dc0f308f.textarea__component_not-resizable_dc0f308f {
  resize: none;
}
.textarea__component_dc0f308f.textarea__component_disabled_dc0f308f {
  resize: none;
}
.textarea__adornment_dc0f308f {
  position: absolute;
  right: 1.334rem;
  bottom: 0.667rem;
  color: #657682;
}
.textarea__adornment_disabled_dc0f308f {
  color: #c1c8cd;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textarea__root": `textarea__root_dc0f308f`,
	"textarea__component": `textarea__component_dc0f308f`,
	"textarea__component_not-resizable": `textarea__component_not-resizable_dc0f308f`,
	"textarea__component_disabled": `textarea__component_disabled_dc0f308f`,
	"textarea__adornment": `textarea__adornment_dc0f308f`,
	"textarea__adornment_disabled": `textarea__adornment_disabled_dc0f308f`
};
export default ___CSS_LOADER_EXPORT___;
